__turbopack_context__.v({
  "accordion": "brand-categories-list-module-scss-module___PE8gq__accordion",
  "active": "brand-categories-list-module-scss-module___PE8gq__active",
  "categoriesList": "brand-categories-list-module-scss-module___PE8gq__categoriesList",
  "content": "brand-categories-list-module-scss-module___PE8gq__content",
  "contentWrapper": "brand-categories-list-module-scss-module___PE8gq__contentWrapper",
  "count": "brand-categories-list-module-scss-module___PE8gq__count",
  "expanded": "brand-categories-list-module-scss-module___PE8gq__expanded",
  "fadeIn": "brand-categories-list-module-scss-module___PE8gq__fadeIn",
  "header": "brand-categories-list-module-scss-module___PE8gq__header",
  "hidden": "brand-categories-list-module-scss-module___PE8gq__hidden",
  "hideButton": "brand-categories-list-module-scss-module___PE8gq__hideButton",
  "icon": "brand-categories-list-module-scss-module___PE8gq__icon",
  "iconOpen": "brand-categories-list-module-scss-module___PE8gq__iconOpen",
  "item": "brand-categories-list-module-scss-module___PE8gq__item",
  "list": "brand-categories-list-module-scss-module___PE8gq__list",
  "loading": "brand-categories-list-module-scss-module___PE8gq__loading",
  "showMoreButton": "brand-categories-list-module-scss-module___PE8gq__showMoreButton",
  "showMoreWrapper": "brand-categories-list-module-scss-module___PE8gq__showMoreWrapper",
  "title": "brand-categories-list-module-scss-module___PE8gq__title",
});
